import { VideoJsPlayerOptions } from 'video.js';

export const exchangeVideoJsOptions: VideoJsPlayerOptions = {
  // id: 'exchange-asset-preview',
  autoplay: false,
  controls: true,
  loop: false,
  preload: 'auto' as 'auto' | 'metadata' | 'none',
  playbackRates: [0.5, 1, 1.5, 2, 5],
  // errorDisplay: false,
  controlBar: {
    volumePanel: { inline: false },
  },
  liveui: true,
};
